import { render, staticRenderFns } from "./form-toggle-switch.vue?vue&type=template&id=1197416f"
import script from "./form-toggle-switch.vue?vue&type=script&lang=js"
export * from "./form-toggle-switch.vue?vue&type=script&lang=js"
import style0 from "./form-toggle-switch.vue?vue&type=style&index=0&id=1197416f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports